import type { ApplicationContext } from '@mimir/common/context/applicationContext';
import { UploadManager } from '../util/UploadManager';
import { uploadManagerOptions } from '../store/uploadManagerOptions';

let uploadManager: UploadManager | undefined;

export function getUploadManager(applicationContext: ApplicationContext) {
  if (!uploadManager) {
    uploadManager = new UploadManager(applicationContext, uploadManagerOptions);
  }

  return uploadManager;
}
